'use client';

import React from 'react';
import { History, PackageSearch } from 'lucide-react';

interface GRNItem {
  id: string;
  invoice: string;
  supplier: string;
  time: string;
}

interface GRNRecentListProps {
  items: GRNItem[];
}

export default function GRNRecentList({ items }: GRNRecentListProps) {
  return (
    <div className="bg-card border border-border rounded-xl overflow-hidden">
      <div className="px-5 py-3.5 border-b border-border flex items-center gap-2">
        <History size={14} className="text-muted-foreground" />
        <h3 className="text-xs font-bold text-foreground uppercase tracking-wider">Recent GRNs — Today</h3>
      </div>

      {items.length === 0 ? (
        <div className="px-5 py-6 flex flex-col items-center gap-2 text-center">
          <PackageSearch size={20} className="text-muted-foreground/40" />
          <p className="text-xs text-muted-foreground">No GRNs registered yet in this session.</p>
        </div>
      ) : (
        <ul className="divide-y divide-border">
          {items.map((item) => (
            <li key={item.id} className="px-5 py-3 flex items-start justify-between gap-3 hover:bg-muted/30 transition-colors">
              <div className="flex-1 min-w-0">
                <p className="text-xs font-mono font-bold text-primary truncate">{item.id}</p>
                <p className="text-2xs text-muted-foreground truncate mt-0.5">{item.invoice} · {item.supplier}</p>
              </div>
              <span className="text-2xs text-muted-foreground flex-shrink-0 mt-0.5">{item.time}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
